import { StandardsSetsHeader } from "@/search/NewSearchPageMVP/FilterPanel/filters/Standards/StandardsModal/shared/StandardsSetsHeader";
import { StandardsList } from "@/search/NewSearchPageMVP/FilterPanel/filters/Standards/StandardsModal/shared/StandardsList";
import { StandardsLoadingSpinner } from "../../shared/StandardsLoadingSpinner";

export const AllStandardsList = () => {
  return (
    <>
      <StandardsSetsHeader />
      <StandardsLoadingSpinner>
        <StandardsList />
      </StandardsLoadingSpinner>
    </>
  );
};

export const allTab = {
  name: "All",
  panelId: "all",
  panelContent: <AllStandardsList />,
};
